const withoutSpecialCharsRegex = /^[^!@#$%^&*()_+\-=[\]{};:"\\|,.<>/?]*$/;
const withoutSpecialCharsAndNumbersRegex = /^[^!@#$%^&*()_+\-=[\]{};:"\\|,.<>/?0-9]*$/;
const withoutSpecialCharsAndNumbersAllowDashRegex = /^[^!@#$%^&*()_+=[\]{};:"\\|,.<>/?0-9]*$/;
const yearRegex = /^\d{4}$/;
const onlyNumbersRegex = /^[0-9]*$/;
const zipCodePLRegex = /^[0-9]{2}-[0-9]{3}$/i;
const streetAddressRegex = /^[^!@#$%^&*()_+=[\]{};/|,<>?]*$/;
const onlyAlphanumericRegex = /^[A-Za-z0-9]*$/;
const withoutSpecialCharsAllowSpaceAndSlashRegex = /^[^!@#$%^&*()_+=[\]{};:"\\|,.<>?]*$/;
const allWhitespacesRegex = /\s/g;
const peselRegex = /^\d{11}$/;

const phonerRegex = /^(?:\+?\d{8,})$/;

const birthDateRegex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[012])\/(19|20)\d\d$/;
const emailDomainRegex =
  /^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*\.[a-zA-Z]{2,}$/;

export {
  withoutSpecialCharsRegex,
  withoutSpecialCharsAndNumbersAllowDashRegex,
  withoutSpecialCharsAndNumbersRegex,
  yearRegex,
  onlyNumbersRegex,
  zipCodePLRegex,
  streetAddressRegex,
  onlyAlphanumericRegex,
  withoutSpecialCharsAllowSpaceAndSlashRegex,
  allWhitespacesRegex,
  peselRegex,
  birthDateRegex,
  phonerRegex,
  emailDomainRegex,
};
